"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requiredProjectNumberFields = exports.getNumberFieldConstraint = exports.PROJECT_TYPE_NUMBER_FIELDS = void 0;
const VERANDA_NUMBER_FIELDS = {
    area: { min: 1, unit: 'm²', required: true },
    removed_area: { min: 0, unit: 'm²', required: false },
    height_below_hook: { min: 1, unit: 'm', required: true },
    height_below_sewer: { min: 1, unit: 'm', required: true },
    width: { min: 0, unit: 'm', required: true },
    length: { min: 0, unit: 'm', required: true },
    base_panel_height: { min: 0, unit: 'm', required: false },
};
const PERGOLA_NUMBER_FIELDS = {
    area: { min: 1, unit: 'm²', required: true },
    removed_area: { min: 0, unit: 'm²', required: false },
    height_below_hook: { min: 1, unit: 'm', required: true },
    height_below_sewer: { min: 1, unit: 'm', required: true },
    width: { min: 1, unit: 'm', required: true },
    length: { min: 1, unit: 'm', required: true },
    base_panel_height: { min: 1, unit: 'm', required: false },
};
const POOL_NUMBER_FIELDS = {
    area: { min: 1, unit: 'm²', required: true },
    removed_area: { min: 0, unit: 'm²', required: false },
    height_min: { min: 0, unit: 'm', required: true },
    height_max: { min: 0, unit: 'm', required: true },
    width: { min: 0, unit: 'm', required: true },
    length: { min: 0, unit: 'm', required: true },
};
exports.PROJECT_TYPE_NUMBER_FIELDS = {
    VERANDA: VERANDA_NUMBER_FIELDS,
    PERGOLA: PERGOLA_NUMBER_FIELDS,
    POOL: POOL_NUMBER_FIELDS,
};
// Constraint for a single field, or undefined when the project type does not
// declare it (e.g. asking a pool for `height_below_hook`). Encapsulates the
// per-type widening so consumers index with a plain string field name.
const getNumberFieldConstraint = (type, field) => exports.PROJECT_TYPE_NUMBER_FIELDS[type][field];
exports.getNumberFieldConstraint = getNumberFieldConstraint;
// The required dimension fields for a project type, in declaration order.
const requiredProjectNumberFields = (type) => Object.entries(exports.PROJECT_TYPE_NUMBER_FIELDS[type])
    .filter(([, c]) => c.required)
    .map(([field]) => field);
exports.requiredProjectNumberFields = requiredProjectNumberFields;
//# sourceMappingURL=form-fields.js.map